/* eslint-disable */
var icon = require('vue-svgicon')
icon.register({
  'raigmore/email': {
    width: 22,
    height: 14,
    viewBox: '0 0 22 14',
    data: '<path pid="0" d="M1.65 0c-.324 0-.622.096-.877.253l9.42 8.051c.497.426 1.1.426 1.598 0l9.435-8.06A1.67 1.67 0 0020.35 0H1.65zM.095 1.094A1.583 1.583 0 000 1.616v10.769C0 13.28.736 14 1.65 14h18.7c.914 0 1.65-.72 1.65-1.615V1.615c0-.183-.038-.357-.095-.521L12.514 9.12a2.342 2.342 0 01-3.042-.008L.095 1.094z" _fill="#303030"/>'
  }
})
